export function commonSearchConfig() {
  if (document.querySelector('.js-commonSearchInput')) {
    const commonSearchInputEle = document.querySelector('.js-commonSearchInput');
    const headerTopSearchBoxEle = document.querySelector('.js-headerTopSearchBox');

    const IS_VIEW = 'is-view';

    commonSearchInputEle.addEventListener('click', (e) => {
      headerTopSearchBoxEle.classList.add(IS_VIEW);
    });

    commonSearchInputEle.addEventListener('blur', (e) => {
      e.target.style.background = '';
    });
  }
}
